<div class="input-container" #inputContainer>

  @if (chat.Mode == 'Person') {
    <sc-chatbot-input-default (submit)="send($event)">
    </sc-chatbot-input-default>
  }

  @if (botMessage && chat.Mode == 'Bot') {
    @if (botMessage?.Type == 'None') {
      <sc-chatbot-input-none [message]="botMessage" (submit)="send($event)">
      </sc-chatbot-input-none>
    }
    @if (botMessage?.Type == 'Text') {
      <sc-chatbot-input-text [message]="botMessage" (submit)="send($event)">
      </sc-chatbot-input-text>
    }
    @if (botMessage?.Type == 'YesNo') {
      <sc-chatbot-input-yes-no [message]="botMessage" (submit)="send($event)">
      </sc-chatbot-input-yes-no>
    }
    @if (botMessage?.Type == 'Choice') {
      <sc-chatbot-input-choice [message]="botMessage" (submit)="send($event)">
      </sc-chatbot-input-choice>
    }
    @if (botMessage?.Type == 'Location') {
      <sc-chatbot-input-location [message]="botMessage" (submit)="send($event)">
      </sc-chatbot-input-location>
    }
    @if (botMessage?.Type == 'FileUpload') {
      <sc-chatbot-input-file-upload [message]="botMessage" (submit)="send($event)">
      </sc-chatbot-input-file-upload>
    }
    @if (botMessage?.Type == 'Range') {
      <sc-chatbot-input-range [message]="botMessage" (submit)="send($event)">
      </sc-chatbot-input-range>
    }
  }

</div>

<div class="lock" [class.show]="chat?.Mode != 'Bot' || message?.isSending"></div>